import styled from 'styled-components';

export const ReopenTicketForm = styled.form``;

export const LeaveModalConfimrationHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ReplyTextarea = styled.textarea`
  width: 100%;
  height: 85px;
  padding: 10px;
  box-sizing: border-box;
  resize: none;
  margin-bottom: 10px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 0.5px solid #222247;
  border-radius: 7px;
`;

export const ConfirmationQues = styled.div`
  font: 18px/24px Biotif;
  letter-spacing: 0px;
  color: #222247;
`;

export const ReopenLabel = styled.div`
  font: normal 18px/28px Biotif;
  letter-spacing: 0px;
  color: #222247;
`;

export const ReopenFooter = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 8px;
  button : {
    border: 1px solid #4948ac;
    border-radius: 4px;
  }
`;
